import React from 'react';
import Hero from './Hero';
import About from './About';
import Music from './Music';
import Visuals from './Visuals';
import Newsletter from './Newsletter';
import Contact from './Contact';
import Navigation from './Navigation';

const Home = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      <Hero />
      <About />
      <div id="music">
        <Music />
      </div>
      <Visuals />
      <Newsletter />
      <Contact />
    </div>
  );
};

export default Home;